module.exports = __webpack_public_path__ + "static/media/studio1-2.7642d7e0.png";